<div class="row mb-2">
  <div class="col"></div>
</div>
<div class="row">
  <div class="col">
    <ref-jeeves-customer-details></ref-jeeves-customer-details>
  </div>
</div>
